import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email, minLength} from "vuelidate/lib/validators";
const file_size_validation = (value) => {
  if (!value) {
    return true;
  }
  let file = value;
  return file.size < 1048576;
};
const image_type_validation = (value) => {
  if (!value) {
    return true;
  }
  let file = value;
  if (
    file.type == "image/svg+xml" ||
    file.type == "image/jpeg" ||
    file.type == "image/gif" ||
    file.type == "image/png"
  ) {
    return true;
  } else {
    return false;
  }
};
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        SearchKey: "",
        CompanyId:0,
        Branches: [],
        Roles: [],
        NewUser: {
          forename: "",
          surname: "",
          email: "",
          password: "",
          company_id: 0,
          phone: "",
          profile_image: "",
          company_role: "1",
          role_id: "",
          branch_ids: [],
          is_2fa_enabled: false,
        },
        ShowAddUser: false,
        FleetSubscription:{}
      };
    },
    validations: {
      NewUser: {
        forename: { required },
        surname: { required },
        email: { required, email },
        password: { required, minLength: minLength(8), // Minimum length of 8 characters
          // You can add additional validation rules for password strength
          strong: (value) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/.test(value),
        },
        phone: { required },
        profile_image: { file_size_validation, image_type_validation },
        role_id: { required },
      },
    },
    mounted() {
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );

      document.title = pbx_SiteTitle + " - User Add";
      this.CompanyId = JSON.parse(localStorage.getItem("Company")).id;
      this.checkPermission();
    },
    methods: {
      Set2FA(type){
        this.NewUser.is_2fa_enabled = type;
      },
      checkPermission(){
        var branchIDs = "";
        if (
          JSON.parse(localStorage.getItem("permissions")) &&
          typeof JSON.parse(localStorage.getItem("permissions")).branch_ids !=
            "undefined"
        ) {
          branchIDs = JSON.parse(
            localStorage.getItem("permissions")
          ).branch_ids;
        }
        var obj = {
          token: localStorage.getItem("token"),
          branchIDs: branchIDs,
        };

        Axios.post(Endpoints.User.AllUser, obj).then((Response) => {
          if (Response?.data?.success) {
            if (this.FleetSubscription.max_fleet_users > Response.data.users.length) {
              this.ShowAddUser = true;
              this.GetBranches();
              this.GetRoles();
            }else {
              this.$swal(
                "You have reached your subscription's maximum allowed users. Please contact us to add more users",
                "",
                "error"
              );
              setTimeout(() => {
                this.$router.push("/users");
              }, 500);
            }
          }
        });
      },
      GetBranches() {
        var obj = { token: localStorage.getItem("token"), select_branch: true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
          }
        });
      },
      GetRoles() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Roles.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Roles = Response.data.records;
          }
        });
      },
      CreateUser() {
        this.submitted = true;
        this.$v.$touch();
        this.NewUser.company_id = this.CompanyId;
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;

        Axios.post(Endpoints.User.Create, {
          token: localStorage.getItem("token"),
          ...this.NewUser,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.SaveProfileImage(Response.data.last_id);
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });

      },
      SaveProfileImage(id) {
        var LogoFormData = new FormData();
        if (this.$refs.ProfileImageFile.files[0]) {
          LogoFormData.append("storage_type", "CFU");
          LogoFormData.append("token", localStorage.getItem("token"));
          LogoFormData.append("file", this.$refs.ProfileImageFile.files[0]);
          LogoFormData.append("company_id", this.CompanyId);
          LogoFormData.append("user_id", id);
          Axios.post(Endpoints.Helper.File.Upload, LogoFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.User.Profile.Image.Set, {
                  token: localStorage.getItem("token"),
                  profile_image: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  this.$swal.fire(
                    "User Added Successfully",
                    "",
                    "success"
                  ).then(() => {
                    this.Saving = false;
                    this.$router.push("/users/" );
                  });
                });
              }
            }
          );
        } else {
          this.$swal.fire("Fleet User Added Successfully", "", "success").then(() => {
            this.Saving = false;
            this.$router.push("/users/" );
          });
        }
      },
      imageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.NewUser.profile_image = files[0];
        var output = document.querySelector(".icon__preview");
        output.src = URL.createObjectURL(files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
      },
    },
  };